import { render, staticRenderFns } from "./FormSpontaneous.vue?vue&type=template&id=16f409d2&scoped=true"
import script from "./FormSpontaneous.vue?vue&type=script&lang=js"
export * from "./FormSpontaneous.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./FormSpontaneous.vue?vue&type=style&index=1&id=16f409d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f409d2",
  null
  
)

export default component.exports